import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../../../components/Pagination";
import SortedHeader from "../../../components/Tables/SortedHeader";
import { InterviewRequestService } from "../../../services/InterviewRequestService";
import RatingItem from "../GlobalClassification/RatingItem";

import AskInterview from "../../../layout/left_menu_icons/ask_interview.svg";

import SideDrawerSearch from "../../../components/SideDrawerSearch";
import FilterForm from "./FilterFom";

export default function ReApplicationsPage() {
  const [Interviewrequests, setInterviewsRequests] = useState([]);
  const [searchObject, setSearchObject] = useState({});
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const { t } = useTranslation();

  const [totalPages, setTotalPages] = useState(0);
  const [filter, setFilter] = useState();
  const [headers, setHeaders] = useState([
    { label: t("Description"), field: "description" },
    { label: t("Candidate email"), field: "candidateEmail" },
    { label: t("Recruiter"), field: "recruiter" },
    { label: t("Manager"), field: "manager" },
    { label: t("Answered on"), field: "answeredOn", sorted: true },
    { label: t("Technical Area "), field: "techArea" },
    { label: t("Technical Role "), field: "techRole" },
    { label: t("Rating"), field: "Rating" },
    { label: t("Last interviewed"), field: "LastInterviewDate" },
    { label: "" }
  ]);
  let pageAndsortactive = useRef(false);
  let loadCurrentUserReapplications = useRef(false);

  function hanldeMessage(event) {
    if (
      event.data === "REAPPLICATIONREFRESH" &&
      event.origin === window.location.origin
    )
      search();
  }

  useEffect(() => {
    window.addEventListener("message", hanldeMessage);

    return () => window.removeEventListener("message", hanldeMessage);
  }, []);
  useEffect(() => {
    if (pageAndsortactive.current) search();
  }, [pageNumber, searchObject.order, searchObject.orderBy]);

  useEffect(() => {
    if (loadCurrentUserReapplications.current) {
      search();
      loadCurrentUserReapplications.current = false;
    }
  }, [searchObject.manager, searchObject.recruiter]);

  useEffect(() => {
    pageAndsortactive.current = true;
    loadCurrentUserReapplications.current = true;
  }, []);

  const clearFilters = () => {
    setSearchObject({});
    setFilter({});
    InterviewRequestService.GetAll(pageSize, pageNumber).then((data) => {
      setInterviewsRequests(data.page);
      setTotalPages(Math.ceil(data.total / pageSize));
    });
  };
  function addFilter(key, value) {
    setFilter({ ...filter, [key]: value });
  }

  function search() {
    InterviewRequestService.GetAll(pageSize, pageNumber, searchObject).then(
      (data) => {
        setInterviewsRequests(data.page);
        setTotalPages(Math.ceil(data.total / pageSize));
      }
    );
  }

  function searchForm() {
    return (
      <FilterForm
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        addFilter={addFilter}
      />
    );
  }

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={AskInterview} alt="ni-icon" />
            <h1 style={{ marginTop: "10px" }}>{t("Re-Applications")}</h1>
          </div>{" "}
          <div className="subtitle">{t("Recruitement/Re-Applications")}</div>
        </div>
      </header>

      <SideDrawerSearch
        searchForm={searchForm}
        onClearFilters={clearFilters}
        onRemoveFilter={clearFilters}
        submitSearch={search}
        filterObject={filter}
        setFilterObject={setFilter}
      >
        <div className="table-wrap">
          <table>
            <thead>
              <SortedHeader
                headers={headers}
                searchObject={searchObject}
                setSearchObject={setSearchObject}
                setHeaders={setHeaders}
              />
            </thead>
            <tbody>
              {Interviewrequests.map((request) => (
                <tr
                  onClick={() =>
                    window.open(
                      `/interview/reapplications/${request.interviewId}/${request.interviewRequestId}`
                    )
                  }
                >
                  <td>{request.description}</td>
                  <td>{request.candidateEmail}</td>
                  <td>{request.recruiter}</td>
                  <td>{request.manager}</td>
                  <td>{moment(request.answeredOn).format("DD-MM-yyyy")}</td>
                  <td>{request.techArea}</td>
                  <td>{request.techRole}</td>
                  <td>
                    {" "}
                    <RatingItem skill={{ rating: request.rating }} />
                    {request.rating}
                  </td>
                  <td>
                    {moment(request.lastInterviewDate).format("DD-MM-yyyy")}
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="row">
          <div className="text-end">
            <Pagination
              totalPages={totalPages}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </SideDrawerSearch>
    </>
  );
}
